/**
 * Stellt ein generisches System für "Kollektionen" bereit, also eine Sammlung von Objekten.
 * Dazu gehören momentan der Warenkorb und die Favoriten.
 */

var $ = require('jquery');
var _ = require('underscore');
var Backbone = require('backbone');
var Promise = require('promise-polyfill');
var ajax = require('ajax');

var Translator = require('translate').singleton;
var __ = Translator.get;

var TemplateCache = require('TemplateCache');
var SafeStorage = require('storage/SafeStorage');


var TraminoCollectibleView = Backbone.View.extend({

	events: {
		'click .items-next': 'handleNext',
		'click .items-prev': 'handlePrev',
		'click .items-remove': 'handleRemove',
		'click .items-reload': 'handleReload',
	},

	initialize: function() {
		this.listenTo(this.model, "change:items change:startIndex change:isLoading", this.render);
	},

	render: function() {
		var startIndex = this.model.get("startIndex");
		var items = this.model.get("items");
		var itemsCount = items ? items.length : 0;
		var perPage = this.model.get("perPage");
		
		if ( items ) {
			items = items.slice(startIndex, startIndex + this.model.get('perPage'));
		} else {
			items = [];
		}

		var nextPageIndex = startIndex + perPage;
		var paginationInfo = [
			__("collectible.results"),
		  	(startIndex + 1),
		  	"-",
		    (nextPageIndex < itemsCount ? nextPageIndex : itemsCount)
		];
		if ( nextPageIndex <= itemsCount ) {
			paginationInfo.push(__("collectible.of"));
			paginationInfo.push(itemsCount);
		}

		this.el.innerHTML = TemplateCache.render(this.model.get("template_id"), {
			isLoading: this.model.get("isLoading"),
			items: items,
			session: this.model.get("session"),
			itemsCount: itemsCount,
			startIndex: startIndex,
			perPage: perPage,
			hasPrev: startIndex > 0,
			hasNext: (startIndex + perPage) < itemsCount,
			paginationInfo: paginationInfo.join(" "),
			text_not_found: this.model.get("text_not_found"),
		});
	},

	handleNext: function(e) {
		e.preventDefault();
		this.model.set("startIndex", this.model.get("startIndex") + this.model.get('perPage'));
	},

	handlePrev: function(e) {
		e.preventDefault();
		this.model.set("startIndex", this.model.get("startIndex") - this.model.get('perPage'));
	},

	handleRemove: function(e) {
		e.preventDefault();
		var item_id = $(e.currentTarget).data().id;
		console.log("TraminoCollectibleView: Remove", item_id);
		if ( item_id ) {
			this.model.remove(item_id);
		}
	},

	handleReload: function(e) {
		e.preventDefault();
		this.model.reload();
	},

});


var TraminoCollectible = Backbone.Model.extend({

	defaults: function() {
		return {
			/* Parameters */
			namespace: null,
			api: null,
			template_id: null,
			render_to: null,
			text_not_found: "Schade, keine Favoriten gefunden...",

			/* Pagination */
			startIndex: 0,
			perPage: 10,

			/* State */
			items: null,
			session: null, /* Created by server */
			isLoading: false,
		};
	},

	initialize: function() {
		_.bindAll(this, 'add', 'remove', 'reload', '_resolve');

		if ( !this.get("namespace") ) throw new Error("TraminoCollectible: A namespace is required");
		if ( !this.get("api") ) throw new Error("TraminoCollectible: A api endpoint is required");
		if ( !this.get("template_id") ) throw new Error("TraminoCollectible: A template_id is required");
		if ( !this.get("render_to") ) throw new Error("TraminoCollectible: A render_to is required");

		let renderTarget = document.getElementById(this.get("render_to"));
		if ( !renderTarget ) {
			console.log(`TraminoCollectible: Element with ID ${this.get("render_to")} not found`);
			renderTarget = $('<div>').hide()[0];
		}

		this.view = new TraminoCollectibleView({
			model: this,
			el: renderTarget,
		});

		this.cache_key = "collectible-" + this.get("namespace");
	},

	/**
	 * Initiale Daten laden (entweder aus dem Cache oder von der API)
	 *
	 * @return {Promise} Triggert wenn der initiale Sync erledigt wurde.
	 *                   Das Ergebnis ist undefiniert und bedeutungslos.
	 */
	init: function() {
		/**
		 * Sometimes when the moon is in the right position and a cruel user is on his desk,
		 * he changes it's cart or favorites in multiple tabs and expects them to be in sync
		 * all the time. So be it.
		 */
		SafeStorage.local.on('change:' + this.cache_key, function(key, value) {
  			console.log("[TraminoCollectible] window storage event was called for key", key);
			this._resolve(Promise.resolve(JSON.parse(value)));
		}.bind(this));

		var cached;
		if ( cached = SafeStorage.local.get(this.cache_key) ) {
			console.log("[TraminoCollectible] Loading from cache");
			return this._resolve(Promise.resolve(JSON.parse(cached)));
		} else {
			console.log("[TraminoCollectible] Loading from API");
			return this.reload();
		}
	},

	/**
	 * Behandelt die Rückgabe vom Server.
	 *
	 * @param request {Promise} Muss die aktuellen Daten vom Server zurückgeben
	 */
	_resolve: function(request) {
		this.set("isLoading", true);
		return request.then(function(data) {
			console.log("[TraminoCollectible] Result", data);
			if ( !data ) return;
			if ( data.status && data.status === "error" ) {
				throw new Error(data.message);
			}
			/* Setzt item, session, und was sonst noch vom Server kommt */
			this.set(data);

			/* We're done (from the user's point of view) */
			this.set("isLoading", false);

			/* Add to cache. This emits a window storage event */
			SafeStorage.local.set(this.cache_key, JSON.stringify(data), 300);
		}.bind(this)).catch(function(e) {
			this.set("isLoading", false);
			console.log(e);
			throw e; // Send to next catch handler
		}.bind(this));
	},

	/**
	 * Fügt eine Seite der Collection hinzu.
	 *
	 * @return {Promise} Promise mit der Liste der aktuellen Favoriten zurück.
	 */
	add: function(item) {
		console.log("[TraminoCollectible] Add", item);
		return this._resolve(ajax({
			url: this.get("api"),
			method: 'post',
			data: {
				action: "add",
				item: JSON.stringify(item),
				session: this.get("session"),
			},
		}));
	},

	/**
	 * Entfernt eine Seite aus der Collection.
	 *
	 * @return {Promise} Promise mit der Liste der aktuellen Favoriten zurück.
	 */
	remove: function(item_id) {
		console.log("[TraminoCollectible] Remove", item_id);
		return this._resolve(ajax({
			url: this.get("api"),
			method: 'post',
			data: {
				action: "remove",
				id: item_id,
				session: this.get("session"),
			},
		}));
	},

	/**
	 * Gibt die Liste aller Items in der Collection aktuellen Benutzer zurück
	 *
	 * @return {Promise} Promise mit der Liste der aktuellen Favoriten zurück.
	 */
	reload: function() {
		return this._resolve(ajax({
			url: this.get("api"),
			method: 'get',
			params: {
				session: this.get("session"),
			},
		}));
	},

	/**
	 * Gibt die aktuelle Anzahl der Items zurück
	 *
	 * @return {Number} Anzahl items
	 */
	count: function() {
		/* items kann null sein (Noch nicht geladen), wir gehen dann davon aus dass wir 0 haben */
		var items = this.get("items");
		return items ? items.length : 0;
	},

	/**
	 * Gibt die Liste der Items zurück
	 */
	getItems: function() {
		return this.attributes.items;
	},

	/**
	 * Gibt alle Items als Objekt für den schnell Zugriff zurück
	 */
	getItemsMap: function() {
		var result = {};
		if ( this.attributes.items && this.attributes.items.length ) {
			for(var i = 0, item; item = this.attributes.items[i]; ++i) {
				result[item.id] = item;
			}
		}
		return result;
	},

});

module.exports = TraminoCollectible;


/* API example */
/*
if ( 0 ) {
	var warenkorb = new TraminoCollectible({
		namespace: "cart",
		api: '/api/cart/items/',
		template_id: 'cart-items-template',
		render_to: 'cart-items-template',
	});
	warenkorb.on('change:items', function() {
		$('..').text(warenkorb.count(), " Favoriten");
	});

	warenkorb.add(150);
	warenkorb.remove(150);
	warenkorb.reload().then(function(results) {

	})
}
*/




/** WEBPACK FOOTER **
 ** /Users/mitch/jsapps/modules/collectible/main.js
 **/